export function TableOptions(model = {}) {
  return {
    page: model.page || 1,
    itemsPerPage: model.itemsPerPage || 10,
    sortBy: model.sortBy || [],
    groupBy: model.groupBy || []
  };
}
